import React from 'react';
import classnames from 'classnames/bind';
import { node, string, bool } from 'prop-types';

import styles from './Hotspots.css';

const cx = classnames.bind(styles);

const Hotspots = ({ children, className, fullwidth, selfcare }) => (
  <section className={classnames(className, cx('hotspots', { fullwidth, selfcare }))}>
    {children}
  </section>
);

Hotspots.propTypes = {
  children: node.isRequired,
  className: string,
  fullwidth: bool,
  selfcare: bool
};

Hotspots.displayName = 'Hotspots';

export default Hotspots;



// WEBPACK FOOTER //
// ./src/uis/components/Hotspots/Hotspots.js